
import { defineComponent } from "vue";
import { DEFAULT_TITLE } from "@/common/constants";

export default defineComponent({
  name: "App",
  watch: {
    $route: {
      handler(to) {
        document.title = to.meta.title || DEFAULT_TITLE;
      },
    },
  },
});
